import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import {
    IStockDeliveryField,
    IStockDeliverySearch,
    IStockDeliveryDetail,
    IDetailsUpdateParams,
    IDetailsFindPageSearch,
    IDetailsFindPageField,
    IStoreInventoryDetail
} from "./stockOutDispatchType"

class StockOutDispatchService {
    async page(searchVo: IStockDeliverySearch) {
        const apiUrl = "/zzw-vrm/maintenance/deliveryPage";
        return await httpRequest.post<IPage<IStockDeliveryDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/maintenance/findById/${id}`;
        return await httpRequest.get<IStockDeliveryDetail>(apiUrl, { timeout: 60000 });
    }
    async deliveryUpdate(params: IStockDeliveryField) {
        const apiUrl = `/zzw-vrm/maintenance/deliveryUpdate`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    async detailsUpdate(params: IDetailsUpdateParams) {
        const apiUrl = `/zzw-vrm/maintenance/detailsUpdate`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //出库
    async stocke(params: IDetailsUpdateParams) {
        const apiUrl = `/zzw-vrm/maintenance/stocke`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //退料入库
    async storage(params: IDetailsUpdateParams) {
        const apiUrl = `/zzw-vrm/maintenance/storage`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //出入库记录查询(采购)
    async detailsFindPage(params: IDetailsFindPageSearch) {
        const apiUrl = `/zzw-vrm/stock/details/details/findPage`;
        return await httpRequest.post<IPage<IDetailsFindPageField>>(apiUrl, params);
    }
    async purchaseHistory(params: IDetailsFindPageSearch) {
        const apiUrl = `/zzw-vrm/purchase/purchaseHistory`;
        return await httpRequest.post<IPage<IDetailsFindPageField>>(apiUrl, params);
    }
    //出入库记录查询(销售)
    async saleHistory(params: IDetailsFindPageSearch) {
        const apiUrl = `/zzw-vrm/sale/saleHistory`;
        return await httpRequest.post<IPage<IDetailsFindPageField>>(apiUrl, params);
    }
    //云修分店库存
    async vrm2Inventory(materialCode: string) {
        const apiUrl = `/zzw-vrm/stock/store/inventory/${materialCode}`;
        return await httpRequest.get<IStoreInventoryDetail[]>(apiUrl);
    }
    //供应链分店库存
    async scm2Inventory(materialCode: string) {
        const apiUrl = `/scm2/stock/statistic/store/inventory/${materialCode}`;
        return await httpRequest.get<IStoreInventoryDetail[]>(apiUrl);
    }
    //供应链分店库存
    async scm2InventoryJH(params: { materialCode: string }) {
        const apiUrl = `/scm2/inventory/summary/report/selectShopInventorySummary/`;
        return await httpRequest.post<IStoreInventoryDetail[]>(apiUrl, params);
    }
    //客车分店库存
    async bcmInventory(params: { materialCode: string }) {
        const apiUrl = `/bcm/stock/store/inventory`;
        return await httpRequest.post<IStoreInventoryDetail[]>(apiUrl, params);
    }
}

export const stockOutDispatchService = new StockOutDispatchService();